export default "__VITE_ASSET__B2mc5Kje__"